import { parseISO, format } from "date-fns";


export const dateFormatter = (date: string, type: "DATE" | "DATETIME") => {
  let ISODate = parseISO(date);

  if (type === "DATE") {
    return format(ISODate, "dd/MM/yyyy");;
  }

  return format(ISODate, "dd/MM/yyyy | HH:mm:ss");
};